
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function ensureCssString(css: string | Array<any>): string {
  if (typeof css === 'string') return css;
  return css
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map((r: any) => (typeof r?.toCSS === 'function' ? r.toCSS() : ''))
    .filter(Boolean)
    .join('\n');
}
